import './styles.scss';
import React from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";

/* Components */
import {ButtonGroup} from "react-bootstrap";
import {ShareItems} from "../../util/share-items";
import {IViewerState} from "../../../types/redux/viewer";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";

const ViewerShare = ():JSX.Element => {
  const currentRecord: any = useSelector<RootState, IViewerState>(state => state.viewer).viewerRecord;

  return  (currentRecord ?
      <div className={'viewer-share px-2'}>
        <ButtonGroup className={'mt-2 d-grid'}>
           <ShareItems
             type={Constants.BUTTON}
             records={[currentRecord]}
           />
        </ButtonGroup>
      </div>
   : <></>
  )
}
export default ViewerShare;
